import React, { memo } from 'react';
import { Site } from 'graphql-common';
import { ChipSizes } from '@lib/components/Chip/Chip';
import CroppedText from '@lib/components/CroppedText/CroppedText';
import SectorChip from '@lib/components/SectorChip/SectorChip';
import styles from './SiteChip.module.scss';

export interface Props {
  disabled?: boolean;
  site?: Site | null;
  size?: ChipSizes;
}

function SiteChip({ disabled, site, size = ChipSizes.medium }: Props) {
  if (!site) return null;
  return (
    <span className={styles.root}>
      <CroppedText className={styles.name} text={site.name} />
      {site.sector && (
        <span className={styles.sector}>
          <SectorChip
            sector={site.sector}
            disabled={disabled}
            showIcon={false}
            size={size}
          />
        </span>
      )}
    </span>
  );
}

export default memo(SiteChip);
